// Mock friend + trade-match data for the Trade tab.
//
// Prototype demo data only. The import.meta.env.PROD ternary on each
// constant causes Vite + terser to eliminate the literals from the
// production bundle entirely. In production users start with an empty
// friend list and trade-match list.

import type { DexCategory } from "./data";
import { RELEASED_IN_GO } from "./constants";

export interface Friend {
  id: string;
  handle: string;        // "@AceTrainerMia"
  displayName: string;   // "Mia"
  trainerCode: string;   // "0481 2235 9907"
  monogram: string;      // "M"
  hue: number;           // for monogram avatar bg
  lastActive: string;    // "2h ago"
  progress: { main: number; shiny: number; lucky: number; perfect: number; purified?: number; xxl?: number; xxs?: number };
  matchCount?: number;   // how many trade matches we found with them
  presenceVisible?: boolean; // v6: when false, friend is shown as 'Private'
}

// Denominator for friend completion bars. Previously hardcoded as 914, which
// rendered >100% bars once a friend's caught count climbed past it. Derived
// from the canonical client constant (mirrors the Worker's NATIONAL_DEX_TOTAL);
// live server totals take precedence wherever a response supplies one.
export const TOTAL_RELEASED = RELEASED_IN_GO;

export const YOUR_INVITE_URL = import.meta.env.PROD ? "" : "nexusdex.ai/invite/sam";

export interface TradeMatch {
  id: string;
  friendId: string;
  // What the FRIEND has, that YOU need
  theyHave: { id: number; name: string; category: DexCategory; note: string };
  // What YOU have, that the FRIEND needs
  youHave: { id: number; name: string; category: DexCategory; note: string };
  rating: 1 | 2 | 3 | 4 | 5;
  scoreLabel: string;
  scoreType: "perfect" | "good" | "low";
}

